<template>
  <transition appear name="fade">
    <div class="ModalCont">
      <div class="overlay" @click="close" @keydown.enter="close" />
      <div class="limit">
        <div class="Modal">
          <slot />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    closeTo: String,
  },
  methods: {
    close() {
      if (this.closeTo) {
        this.$router.push({ name: this.closeTo })
      }

      this.$emit('close')
    },
  },
}
</script>

<style lang="scss">
@import '../../style/variables';

.ModalCont {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 7;

  > .overlay {
    background: rgba(darken($main, 55%), 0.7);
    height: 100%;
    pointer-events: all;
    position: fixed;
    width: 100%;
  }

  > .limit {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    max-height: 100%;
    max-width: 840px;
    right: 0;
    top: 0;
    width: 100%;
  }

  &.lg .Modal {
    max-height: 95%;
    max-width: 95%;
  }
}
</style>
